<template>
    <div class="inner-box">
         
        <!-- 기사정보1 그리드 s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name"> </h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix" v-if="!bReadOnly">
                        
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            :enableRangeSelection="true"
                            :column-defs="columnDefs"
                            :grid-options="gridOptions"
                            :row-data="data"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReadyMain"
                            :statusBar="statusBar"
                            @cell-clicked="onCellClicked" />
                    </div>
                </div>
            </div>
        </div>
        <!-- 기사정보1 그리드 e.-->

        <!-- 기사정보2 그리드 s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="subGrid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            row-selection="single"
                            :column-defs="subColumnDefs"
                            :grid-options="subGridOptions"
                            :row-data="subData"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReadySub"
                            :statusBar="statusBar" />
                    </div>
                </div>
            </div>
        </div>
        <!-- 기사정보2 그리드 e.-->
    </div>
</template>


<script>
/**
 * * mixins
 */
import slip from '@/mixin/slip';
import common from '@/mixin/common';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';

/**
 * * Modal
 */
import ModelSelectModal from '@/components/AS/NormalConsult/Modal/ModelSelectModal.vue';
import CSChgModal from '@/components/AS/NormalConsult/Modal/CSChgModal.vue';
import CallReadModal from '@/components/AS/NormalConsult/Modal/CallReadModal.vue';


/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

/**
 * 객체내의 값 초기화
 */
 $.ObjectInitialize = function (obj) {
    let self = this;
    self.obj = obj;

    $.each(obj, function (item_name, item) {
        let datatype = $.type(item);

        if (datatype == "number")
            self.obj[item_name] = 0;   // 정수는 0 으로 초기화

        else if (datatype == "string")
            self.obj[item_name] = '';   // 문자는 '' 으로 초기화

        else if (datatype == "boolean")
            self.obj[item_name] = false;   // boolean 는 false 으로 초기화

        else if (datatype == "array")
            self.obj[item_name] = [];   // 배열은 [] 으로 초기화

        else if (datatype == "object")
            self.obj[item_name] = {};   // object는  {} 으로 초기화

    });
} 

export default {
    mixins: [slip, common],
    components: {AgGridVue, DhxCalendar},
    props: ['custParam'],
    data() {
        return {
            form: {
                userCd: '', /** ID */
                groupNm: '', /** 그룹구분 */
                positionCd: '', /** 직급 */
                userNm: '', /** 성명 */
                carNo: '', /** 차량번호 */
                enterDt: '', /** 입사일자 */
                area: '', /** 담당지역 */
                hpNo: '', /** 휴대폰 */
                weekMorning: '', /** 평일오전 */
                weekAfternoon: '', /** 평일 오후 */
                weekendMorning: '', /** 주말오전 */
                weekendAfternoon: '' /** 주말 오후 */
            },
            callClassOpt: [], /** 상담유형리스트 */
            callClassIdOpt: [], /** 상담유형리스트 Id */
            callCatIdOpt1: [], /** 상담분류(대) */
            callCatIdIdOpt1: [], /** 상담분류(대) Id */
            callCatIdOpt2: [], /** 상담분류(중) */
            callCatIdIdOpt2: [], /** 상담분류(중) Id */
            callCatIdOpt3: [], /** 상담분류(소) */
            callCatIdIdOpt3: [], /** 상담분류(소) Id */
            callTypeRadio: [], /** 처리결과 */
            bReadOnly: false,  /** 비활성화 여부 */
            data: [],
            subData: [{
                userCd: '', /** ID */
                groupNm: '', /** 그룹구분 */
                positionCd: '', /** 직급 */
                userNm: '', /** 성명 */
                carNo: '', /** 차량번호 */
                enterDt: '', /** 입사일자 */
                area: '', /** 담당지역 */
                hpNo: '', /** 휴대폰 */
                weekMorning: '', /** 평일오전 */
                weekAfternoon: '', /** 평일 오후 */
                weekendMorning: '', /** 주말오전 */
                weekendAfternoon: '' /** 주말 오후 */
            }],
            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 40px; width: 100%;height: 300px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter:false
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            subColumnDefs: [],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            subGridApi: null,
            subColumnApi: null,
            subGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                
            },
            statusBar: null,
            //AG-GRID OPTION [END]
        }
    },
    computed: {
        
    },
    created() {
        this.statusBar = {
            statusPanels: [
                { statusPanel: 'agTotalRowCountComponent', align: 'right' },
            ],
        };
    },
    mounted() {
        this.getCombo({flag: 'INIT'})
        this.setNormalList();
    },
    methods: {
        onReadyMain() { 
            //메인그리드 api 정의
            this.gridApi = this.gridOptions.api;
            this.columnApi = this.gridOptions.columnApi;
            this.createColumnDefs();
            this.createSubColumnDefs();
        },
        onReadySub() {
            this.subGridApi = this.subGridOptions.api;
            this.subColumnApi = this.subGridOptions.columnApi;
        },
        setNormalList(param){
            console.log('setNormalList Tab2: ', param);
            if(param){
                this.data = param || [];
                this.subData = [{
                        userCd: '', /** ID */
                        groupNm: '', /** 그룹구분 */
                        positionCd: '', /** 직급 */
                        userNm: '', /** 성명 */
                        carNo: '', /** 차량번호 */
                        enterDt: '', /** 입사일자 */
                        area: '', /** 담당지역 */
                        hpNo: '', /** 휴대폰 */
                        weekMorning: '', /** 평일오전 */
                        weekAfternoon: '', /** 평일 오후 */
                        weekendMorning: '', /** 주말오전 */
                        weekendAfternoon: '' /** 주말 오후 */
                    }]; // 초기화
                    
            } else if (this.custParam && this.custParam.tab2ServiceEngineerSelAgent){
                this.data = this.custParam.tab2ServiceEngineerSelAgent || [];
            }
        },
        createColumnDefs() {
            const vm = this;
            this.columnDefs=[
                {
                    headerName:'ID', 
                    field:'userCd', 
                    width:140,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'그룹구분', 
                    field:'groupNm', 
                    width:150,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'직급', 
                    field:'positionCd', 
                    width:230,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName: '성명', 
                    field:'userNm', 
                    width: 140,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '차량번호', 
                    field:'carNo', 
                    width: 140,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '입사일자', 
                    field:'enterDt', 
                    width: 140,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '담당지역', 
                    field:'area', 
                    width: 140,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '휴대폰', 
                    field:'hpNo', 
                    width: 140,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '평일', 
                    field:'today', 
                    children: [{
                        headerName: '오전',
                        field: 'weekMorning',
                        headerClass: 'hide-cell',
                        width: 90
                    },{
                        headerName: '오후',
                        field: 'weekAfternoon',
                        headerClass: 'hide-cell',
                        width: 90
                    }],
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '토요일',
                    headerClass: 'header-rowspan-2',
                    children: [{
                        headerName: '오전',
                        field: 'weekendMorning',
                        headerClass: 'hide-cell',
                        width: 90
                    },{
                        headerName: '오후',
                        field: 'weekendAfternoon',
                        headerClass: 'hide-cell',
                        width: 90
                    }],
                    cellStyle:{textAlign:'center'}
                } 
            ]
        },
        createSubColumnDefs() {
            const vm = this;
            this.subColumnDefs=[
            {
                    headerName:'ID', 
                    field:'userCd', 
                    width:140,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'그룹구분', 
                    field:'groupNm', 
                    width:150,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'직급', 
                    field:'positionCd', 
                    width:230,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName: '성명', 
                    field:'userNm', 
                    width: 140,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '차량번호', 
                    field:'carNo', 
                    width: 140,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '입사일자', 
                    field:'enterDt', 
                    width: 140,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '담당지역', 
                    field:'area', 
                    width: 140,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '휴대폰', 
                    field:'hpNo', 
                    width: 140,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '평일', 
                    field:'today', 
                    children: [{
                        headerName: '오전',
                        field: 'weekMorning',
                        headerClass: 'hide-cell',
                        width: 90
                    },{
                        headerName: '오후',
                        field: 'weekAfternoon',
                        headerClass: 'hide-cell',
                        width: 90
                    }],
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '토요일',
                    headerClass: 'header-rowspan-2',
                    children: [{
                        headerName: '오전',
                        field: 'weekendMorning',
                        headerClass: 'hide-cell',
                        width: 90
                    },{
                        headerName: '오후',
                        field: 'weekendAfternoon',
                        headerClass: 'hide-cell',
                        width: 90
                    }],
                    cellStyle:{textAlign:'center'}
                } 
            ]
        },
        onCellClicked(params) {
            //const idx = params.rowIndex;
            console.log('normal onCellClicked 2 : ', params.data)
            const field = params.colDef.field;
            
            this.subData = [params.data];

            // this.subGridApi.redrawRows({ rowNodes: params });
            
            console.log('normal onCellClicked this.subData : ', this.subData)
        },
        onSubCellClicked(params) {
            //const idx = params.rowIndex;
            console.log('onSubCellClicked : ', params)

        },
        openModel(param) {
            /** 일반상담상세내역 팝업 */

            let vm = this;
            this.$modal.open({
                width: 950,
                component: CallReadModal,
                parent: this,
                props: {
                    data: {
                        callId: param.callId,
                        callTypeRadio: vm.callTypeRadio
                    }
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        openModal() {
            let vm = this;
            this.$modal.open({
                width: 800,
                component: CSChgModal,
                parent: this,
                props: {
                    data: {
                        
                    },
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
        getCombo(param) {
            if(param.flag === 'INIT'){
                // 접수유형 : CallCat 2레벨
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 41}})
                .then(response => {
                    this.callClassOpt = response.data || []
                });

                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 41}})
                .then(response => {
                    this.callClassIdOpt = response.data || []
                });
                
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 16}})
                .then(response => {
                    this.callTypeRadio = response.data || []
                    if(response && response.data.length > 0){
                        this.form.callType = response.data[0].key
                    }
                });

            }else if(param.flag === 'CHG0'){
console.log(' getCombo CHG0 :', param)
                // 상담분류(대)
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdOpt1 = _.cloneDeep(response.data) || []
                        this.form.callCatId = ''
                    });
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdIdOpt1 = _.cloneDeep(response.data) || []
                });   

            }else if(param.flag === 'CHG1'){
console.log(' getCombo CHG1 :', param)
                // 상담분류(대)
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdOpt2 = _.cloneDeep(response.data) || []
                        this.form.callCatId2 = ''
                    });
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdIdOpt2 = _.cloneDeep(response.data) || []
                });    
            }else if(param.flag === 'CHG2'){
console.log(' getCombo CHG2 :', param)
                // 상담분류(대)
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdOpt3 = _.cloneDeep(response.data) || []
                        this.form.callCatId3 = ''
                    }); 
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: param.parentId}})
                    .then(response => {
                        this.callCatIdIdOpt3 = _.cloneDeep(response.data) || []
                    });    
            }
        },
        onCallClassChange0(value){

            // 초기화
            // 상담분류(대)
            this.callCatIdOpt1 = JSON.parse(JSON.stringify([]))
            this.callCatIdIdOpt1 = JSON.parse(JSON.stringify([]))
            this.form.callCatId1 = ''

            if(this.form.callClass != '') { // 상담유형이 공백이 아닌 경우
                const vIdx = this.callClassOpt.findIndex(x=>x.key === value)
                const vParentId = this.callClassIdOpt[vIdx].key || 0

                this.getCombo({flag: 'CHG0', parentId: vParentId})
                this.form.catId = vParentId
            }

            // 초기화
            this.callCatIdOpt2 = JSON.parse(JSON.stringify([]))
            this.callCatIdIdOpt2 = JSON.parse(JSON.stringify([]))
            this.form.callCatId2 = ''
            this.callCatIdOpt3 = JSON.parse(JSON.stringify([]))
            this.callCatIdIdOpt3 = JSON.parse(JSON.stringify([]))
            this.form.callCatId3 = ''
 
        },
        onCallClassChange1(value){

            // 초기화
            
            this.callCatIdOpt2 = JSON.parse(JSON.stringify([]))
            this.callCatIdIdOpt2 = JSON.parse(JSON.stringify([]))
            this.form.callCatId2 = ''

            if(this.form.callCatId1 != '') {
                const vIdx = this.callCatIdOpt1.findIndex(x=>x.key === value)
                const vParentId = this.callCatIdIdOpt1[vIdx].key || 0

                this.getCombo({flag: 'CHG1', parentId: vParentId})
                this.form.catId = vParentId
            }
            
            // 초기화
            this.callCatIdOpt3 = JSON.parse(JSON.stringify([]))
            this.callCatIdIdOpt3 = JSON.parse(JSON.stringify([]))
            this.form.callCatId3 = ''
        },
        onCallClassChange2(value){

            const vIdx = this.callCatIdOpt2.findIndex(x=>x.key === value)
            const vParentId = this.callCatIdIdOpt2[vIdx].key || 0

            this.getCombo({flag: 'CHG2', parentId: vParentId})
            this.form.catId = vParentId
        },
        onCallClassChange3(value){

            const vIdx = this.callCatIdOpt3.findIndex(x=>x.key === value)
            const vParentId = this.callCatIdIdOpt3[vIdx].key || 0
             
            this.form.catId = vParentId
        },
        searchModel(){
            /** 모델선택 */
            let vm = this;
            this.$modal.open({
                width: 800,
                component: ModelSelectModal,
                parent: this,
                props: {
                    data: {
                        
                    },
                },
                events: {
                    close(param) {
                        console.log('close', param);
                        vm.form.maker = param.data.maker /** 제조사 */
                        vm.form.makerNm = param.data.makerNm /** 제조사명 */
                        vm.form.modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
                        vm.form.modelGroup = param.data.modelGroup /** 모델그룹 */
                        vm.form.standardModelNm = param.data.standardModelNm /** 표준모델 */
                        vm.form.modelNm = param.data.modelNm /** 모델명 */
                        vm.form.modelId = param.data.modelId /** 모델ID */
                    },
                }
            });

        },
        viewSpec(){
            /** 사양보기 */
        },
        enableChk(param){
            /** 입력항목 활성화처리 */
            console.log('enableChk start :', param);
            if(param === 'IN_CALL_ID'){
                if(this.form.callType === 'Processing'){
                    // 처리결과가 미완료이면 수정가능해야 함.
                    this.bReadOnly = false;
                } else {
                    this.bReadOnly = true;
                }
                
            } else {
                this.bReadOnly = false;
            }
        }
    }
}
</script>

<style scoped>
.el-form {
    border: 1px solid #c7c7c7;
    padding: 10px;
    border-radius: 5px;
}
</style>